// extracted by mini-css-extract-plugin
export default {"loader":"fufuButton_loader__Blm4b"};